module.exports = __webpack_public_path__ + "static/media/sidebar-3.c963330b.jpg";